'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _restaurantsTwitterProxyClient = require('@wix/restaurants-twitter-proxy-client');

exports.default = function (path, params) {
    var twitterApi = new _restaurantsTwitterProxyClient.TwitterProxyClient({ XMLHttpRequest: XMLHttpRequest });
    return twitterApi.api({ path: path, params: params });
};